import React from "react";
import styled from "@emotion/styled";
import mq from "../utils/mediaQueries";
import useWindowSize from "../hooks/useWindowSize";
import { breakpoints } from "../hooks/useBreakpoint";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${({ theme }) => theme.header};
  justify-content: center;
  align-items: center;
  height: auto;

  ${mq("sm")} {
    justify-content: space-between;
    flex-direction: row;
    height: 36px;
  }
`;

const Button = styled.button`
  padding: 1rem;
  border: none;
  background-color: inherit;
  cursor: pointer;
  display: inline-block;
  color: ${({ theme }) => theme.black};
  font-family: "Press Start 2P", monospace;
  font-size: 0.8rem;
  margin-left: 1rem;
  margin-right: 1rem;
  -webkit-tap-highlight-color: transparent;

  :hover {
    color: ${({ theme }) => theme.white};
  }

  :active {
    color: ${({ theme }) => theme.body};
  }

  span {
    color: ${({ theme }) => theme.black};
  }

  ${mq("sm")} {
    padding: 0.25rem;
  }

  :only-child {
    margin: auto;
  }
`;

const Link = styled.a`
  padding: 1rem;
  border: none;
  background-color: inherit;
  cursor: pointer;
  display: inline-block;
  color: ${({ theme }) => theme.black};
  font-family: "Press Start 2P", monospace;
  font-size: 0.8rem;
  margin-left: 1rem;
  margin-right: 1rem;
  -webkit-tap-highlight-color: transparent;
  text-decoration: none;
  vertical-align: middle;

  :hover {
    color: ${({ theme }) => theme.white};
  }

  :active {
    color: ${({ theme }) => theme.body};
  }

  span {
    color: ${({ theme }) => theme.black};
  }

  ${mq("sm")} {
    padding: 0.25rem;
  }
`;

const Menu = ({
  reroll,
  print,
  showRender = true,
  showContact = true,
  showPrint = true,
}) => {
  const { width } = useWindowSize();

  const pluses = () => {
    if (width <= breakpoints.xxs) return "";
    if (width < breakpoints.lg) return "+";
    return "+++";
  };

  return (
    <Wrapper>
      {showRender && (
        <Button onClick={reroll}>
          <span>{pluses()}</span> Render new life <span>{pluses()}</span>
        </Button>
      )}
      {showPrint && (
        <Button onClick={print}>
          <span>{pluses()}</span> Print page <span>{pluses()}</span>
        </Button>
      )}
      {showContact && (
        <Link href="https://discord.com/invite/YSfrKXv" target="_blank">
          <span>{pluses()}</span> Cont@ct sysops <span>{pluses()}</span>
        </Link>
      )}
    </Wrapper>
  );
};

export default Menu;
